import React, {Component} from "react";
import {connect} from "react-redux";
import ActionButton from "../../components/ActionButton";
import {graphql} from "react-apollo";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {ORDER_ACTIONS_VIEW, ON_ORDER_ACTIONS_VIEW_UPDATED} from "../../queries/shipping";
import {fromJS} from "immutable";

class OrderActions extends Component {

  UNSAFE_componentWillMount() {
    this.subscribe(this.props); 
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.orderId && (prevProps.orderId !== this.props.orderId)) {
      this.subscribe(this.props);
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  subscribe(props) {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToUpdates(props, {});
  }


  render() {
    if (!this.props.show) return null;
    let {loading, error, shippingOrderActionsView} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let info = fromJS(shippingOrderActionsView);

    return (
      <React.Fragment>
        <ActionButton 
          label="Start Shipment Manually" 
          active={info.get("canStartShipment", false)}
          onClick={this.props.onProcessShipment} />
        <ActionButton 
          label="Schedule Shipment" 
          active={info.get("canScheduleShipment", false)}
          onClick={this.props.onScheduleShipment} />
        <ActionButton 
          label="Unschedule Shipment" 
          active={info.get("canUnscheduleShipment", false)}
          onClick={this.props.onUnscheduleShipment} />
        <ActionButton 
          label="Change Delivery Address" 
          active={info.get("canChangeAddress", false)}
          onClick={this.props.onChangeAddress} />
        <ActionButton
          label="Set Delivery Instructions"
          active={info.get("canChangeAddress", false)}
          onClick={this.props.onSetDeliveryInstructions} />
        <ActionButton
          label="Assign Warehouse"
          active={info.get("canAssignWarehouse", false)}
          show={info.get("canAssignWarehouse")}
          onClick={this.props.onAssignWarehouse} />
        <ActionButton
          label="Change Warehouse"
          active={info.get("canChangeWarehouse", false)}
          show={info.get("canChangeWarehouse")}
          onClick={this.props.onChangeWarehouse} />
        <ActionButton 
          label="Add Product" 
          active={info.get("canAddProduct", false)}
          onClick={this.props.onAddProduct} />          
        <ActionButton 
          label="Request Shipping Quote" 
          active={info.get("canRequestQuote", false)}
          onClick={this.props.onRequestQuote} />          
        <ActionButton 
          label="Reserve Stock" 
          active={info.get("canReserveStock", false)}
          onClick={this.props.onReserveStock} />
        <ActionButton 
          label="Accept Shipping Quote" 
          active={info.get("canAcceptQuote", false)}
          onClick={this.props.onAcceptQuote} />
        <ActionButton 
          label="Void Shipment" 
          active={info.get("canVoidShipment", false)}
          onClick={this.props.onVoidShipment}
          />
        <ActionButton
          label="Hold Shipment"
          active={true}
          onClick={this.props.onHoldShipment}
          />
        <ActionButton
          label="Release Shipment Hold"
          active={true}
          onClick={this.props.onReleaseShipmentHold}
          />
        <ActionButton
          label="Mark As Complimentary"
          active={true}
          onClick={this.props.onMarkAsComplimentary}
          />
        <ActionButton 
          label="Cancel Order" 
          active={info.get("canCancelOrder", false)}
          onClick={this.props.onCancelOrder}
          />
      </React.Fragment>
    )
  }

}

const withQuery = graphql(ORDER_ACTIONS_VIEW, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      orderId: props.orderId
    }
  })
})

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_ORDER_ACTIONS_VIEW_UPDATED,
      variables: {
        orderId: props.orderId
      },
      updateQuery: (prev, { subscriptionData }) => {
        console.log("UPDATED!!", subscriptionData);
        if (!subscriptionData.data) {
          return prev;
        }
        return {
          shippingOrderActionsView: subscriptionData.data.updatedShippingOrderActionsView
        }
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);
export default withQuery(withSubscription(OrderActions));